import type { NnnRegistrationRowKenmerk } from '@/api';
import type { NandaDiagnoseKenmerk, NandaDiagnoseKenmerken } from '@/services';
import type { NnnKenmerkType } from '../types/careplan-nnn.types';
import { kenmerkenOfType } from './build-kenmerk-secties';

export function includeSelectedKenmerken(
  kenmerken: NandaDiagnoseKenmerken,
  selected: NnnRegistrationRowKenmerk[]
): NandaDiagnoseKenmerken {
  return {
    bepalendeKenmerken: withMissing(kenmerken, 'BEPALEND_KENMERK', selected),
    samenhangendeFactoren: withMissing(kenmerken, 'SAMENHANGENDE_FACTOR', selected),
    risicoFactoren: withMissing(kenmerken, 'RISICO_FACTOR', selected),
  };
}

function withMissing(
  kenmerken: NandaDiagnoseKenmerken,
  type: NnnKenmerkType,
  selected: NnnRegistrationRowKenmerk[]
): NandaDiagnoseKenmerk[] {
  const known = kenmerkenOfType(kenmerken, type);
  const knownCodes = new Set(known.filter(k => k.code !== null).map(k => String(k.code)));
  const missing = selected
    .filter(k => k.type === type && !knownCodes.has(k.nnnKenmerkDbRef) && !Number.isNaN(Number(k.nnnKenmerkDbRef)))
    .map<NandaDiagnoseKenmerk>(k => ({
      code: Number(k.nnnKenmerkDbRef),
      omschrijving: k.nnnKenmerkDbRef,
      categorie: null,
      type: null,
      isActive: false,
    }));
  return missing.length === 0 ? known : [...known, ...missing];
}
